import Head from "next/head";

export default function Sitemap() {
  return (
    <>
      <Head>
        <title>Sitemap - Kyoto Toyota</title>
        <meta name="robots" content="noindex, follow" />
      </Head>
      <div className="max-w-[1200px] text-black mx-auto p-5">
        <h1 className="text-3xl mb-8">Sitemap Kyoto Toyota</h1>
        <div className="sitemap">
          <div className="mb-8">
            <h2 className="text-red-600 border-b-2 border-red-600 pb-2 mb-4">
              Páginas Principais
            </h2>
            <ul className="pl-5">
              <li className="my-2">
                <a href="/" className="hover:text-red-600">
                  Home
                </a>
              </li>
              <li className="my-2">
                <a href="/sobre" className="hover:text-red-600">
                  Sobre
                </a>
              </li>
              <li className="my-2">
                <a href="/cookies" className="hover:text-red-600">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-red-600 border-b-2 border-red-600 pb-2 mb-4">
              Serviços
            </h2>
            <ul className="pl-5">
              <li className="my-2">
                <a href="/servicos/pos-venda" className="hover:text-red-600">
                  Pós-Venda
                </a>
              </li>
              <li className="my-2">
                <a href="/garantiatoyota" className="hover:text-red-600">
                  Garantia Toyota
                </a>
              </li>
              <li className="my-2">
                <a href="/kinto" className="hover:text-red-600">
                  Kinto
                </a>
              </li>
              <li className="my-2">
                <a href="/servicos/blindagem" className="hover:text-red-600">
                  Blindagem
                </a>
              </li>
              <li className="my-2">
                <a href="/servicos/pecas" className="hover:text-red-600">
                  Peças
                </a>
              </li>
              <li className="my-2">
                <a href="/servicos/ciclo-toyota" className="hover:text-red-600">
                  Ciclo Toyota
                </a>
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-red-600 border-b-2 border-red-600 pb-2 mb-4">
              Venda Direta
            </h2>
            <ul className="pl-5">
              <li className="my-2">
                <a
                  href="/venda-direta/produtor-rural"
                  className="hover:text-red-600"
                >
                  Produtor Rural
                </a>
              </li>
              <li className="my-2">
                <a
                  href="/venda-direta/pessoa-com-deficiencia"
                  className="hover:text-red-600"
                >
                  Pessoa com Deficiência
                </a>
              </li>
              <li className="my-2">
                <a href="/venda-direta/taxista" className="hover:text-red-600">
                  Taxista
                </a>
              </li>
              <li className="my-2">
                <a href="/venda-direta/governo" className="hover:text-red-600">
                  Governo
                </a>
              </li>
              <li className="my-2">
                <a href="/venda-direta/frotista" className="hover:text-red-600">
                  Frotista
                </a>
              </li>
              <li className="my-2">
                <a href="/venda-direta/cnpj" className="hover:text-red-600">
                  CNPJ
                </a>
              </li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-red-600 border-b-2 border-red-600 pb-2 mb-4">
              Veículos
            </h2>
            <ul className="pl-5">
              <li className="my-2">
                <a href="/corolla" className="hover:text-red-600">
                  Corolla
                </a>
              </li>
              <li className="my-2">
                <a href="/corolla-cross" className="hover:text-red-600">
                  Corolla Cross
                </a>
              </li>
              <li className="my-2">
                <a href="/yaris-cross" className="hover:text-red-600">
                  Yaris Cross
                </a>
              </li>
              <li className="my-2">
                <a href="/hilux" className="hover:text-red-600">
                  Hilux
                </a>
              </li>
              <li className="my-2">
                <a href="/rav4" className="hover:text-red-600">
                  RAV4
                </a>
              </li>
              <li className="my-2">
                <a href="/sw4" className="hover:text-red-600">
                  SW4
                </a>
              </li>
              <li className="my-2">
                <a href="/bz4x" className="hover:text-red-600">
                  bZ4X
                </a>
              </li>
              <li className="my-2">
                <a href="/corolla-hatch" className="hover:text-red-600">
                  Corolla Hatch
                </a>
              </li>
              <li className="my-2">
                <a href="/hiace" className="hover:text-red-600">
                  Hiace
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
